"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_client_1 = __importDefault(require("@fuze/apis-core/dist/http-client"));
var getDefaultHeaders_1 = __importDefault(require("../../getDefaultHeaders"));
/**
 * Returns a list of options for a give user
 * This is used to identify the authentication mechanism
 *
 * @param userKey A Fuze username or email
 */
function getOptions(baseUrl, applicationKey, userKey) {
    return http_client_1.default({
        method: "GET",
        url: baseUrl + "/api/v4/users/" + userKey + "/auth/options",
        headers: getDefaultHeaders_1.default(applicationKey)
    }).then(function (response) { return response.data; });
}
exports.default = getOptions;
